export const formItemName = {
  product: 'いずれか',
  userName: 'お名前',
  pronunciation: 'フリガナ',
  companyName: 'ご勤務先',
  phoneNumber: '電話番号',
  email: 'メールアドレス',
  confirmEmail: '確認用メールアドレス',
  homeAddress: 'ご住所',
}

export const isPC = $(window).width() >= 1100

export const isTB = $(window).width() >= 960 && $(window).width() < 1100